module.exports = __webpack_public_path__ + "static/img/radio-active.80b5157a.png";